export const CARD_CONFIG = {
    // Card Dimensions
    CARD_WIDTH: 180,
    CARD_HEIGHT: 220,
    CARD_THICKNESS: 0.5,
    
    // Animation Timing (in seconds)
    FLIP_DURATION: 0.6,
    DEAL_DURATION: 0.3,
    COLLECT_DURATION: 0.4,
    
    // Animation Effects
    FLIP_SPRING_CONFIG: {
        tension: 180,
        friction: 12,
        mass: 1
    },
    
    // Card Positioning
    SPACING: {
        HORIZONTAL: 180,
        VERTICAL: 240,
        STACK: 0.2
    },
    
    // Visual Effects
    HOVER_LIFT: 20,
    HOVER_ROTATION: 5,
    SHADOW_OPACITY: 0.3,
    
    // Card States
    STATES: {
        DECK: 'deck',
        DEALING: 'dealing',
        IDLE: 'idle',
        FLIPPING: 'flipping',
        FLIPPED: 'flipped',
        COLLECTING: 'collecting'
    },
    
    // Card Types
    TYPES: {
        NORMAL: 'normal',
        SPECIAL: 'special',
        RARE: 'rare',
        LEGENDARY: 'legendary'
    },
    
    // Effects
    EFFECTS: {
        GLOW: {
            color: '#00ff00',
            intensity: 2,
            radius: 10
        },
        SPARKLE: {
            particleCount: 20,
            duration: 1,
            spread: 45
        }
    },
    
    // Sound Effects
    SOUNDS: {
        FLIP: 'flip.mp3',
        DEAL: 'deal.mp3',
        MATCH: 'match.mp3',
        SPECIAL: 'special.mp3'
    }
};
